module.exports = __webpack_public_path__ + "static/media/manager-guide-icon-motivate.79875d1a.svg";